export default {
  state: {
    qtCate: 1, // 分发送的是：0引导问题，1手动输入，2追问问题，3弹窗问题，4划词问题，5icon弹泡、6banner点击、7卡片点击
    interfaceError: false,
  },
  mutations: {
    setQtCate(state, data) {
      state.qtCate = data;
    },
    setInterfaceError(state, data) {
      state.interfaceError = data;
    },
  },
};
